import { neutralTile } from './utils';

/**
 * The brand kit has one colour of structure (navy) and no per-company hues, so every
 * company wears the same badge and the monogram alone says which one it is.
 */
export const IDENTITY_BADGE = neutralTile;

/**
 * Up to two letters, taken from the first two words — "Corvino Robotics"
 * reads as CR, "Vento Alto" as VA. One word gives its first two letters, so a
 * monogram is never a single lonely character.
 */
export function monogram(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}
